"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
});

var r = require("react"),
    _e = function e() {
  return (_e = Object.assign || function (r) {
    for (var e, t = 1, n = arguments.length; t < n; t++) {
      for (var u in e = arguments[t]) {
        Object.prototype.hasOwnProperty.call(e, u) && (r[u] = e[u]);
      }
    }

    return r;
  }).apply(this, arguments);
};

function t(r, e) {
  var t = {};

  for (var n in r) {
    Object.prototype.hasOwnProperty.call(r, n) && e.indexOf(n) < 0 && (t[n] = r[n]);
  }

  if (null != r && "function" == typeof Object.getOwnPropertySymbols) {
    var u = 0;

    for (n = Object.getOwnPropertySymbols(r); u < n.length; u++) {
      e.indexOf(n[u]) < 0 && Object.prototype.propertyIsEnumerable.call(r, n[u]) && (t[n[u]] = r[n[u]]);
    }
  }

  return t;
}

function n(r, e, t, n) {
  return new (t || (t = Promise))(function (u, i) {
    function a(r) {
      try {
        o(n.next(r));
      } catch (r) {
        i(r);
      }
    }

    function c(r) {
      try {
        o(n.throw(r));
      } catch (r) {
        i(r);
      }
    }

    function o(r) {
      var e;
      r.done ? u(r.value) : (e = r.value, e instanceof t ? e : new t(function (r) {
        r(e);
      })).then(a, c);
    }

    o((n = n.apply(r, e || [])).next());
  });
}

function u(r, e) {
  var t,
      n,
      u,
      i,
      a = {
    label: 0,
    sent: function sent() {
      if (1 & u[0]) throw u[1];
      return u[1];
    },
    trys: [],
    ops: []
  };
  return i = {
    next: c(0),
    throw: c(1),
    return: c(2)
  }, "function" == typeof Symbol && (i[Symbol.iterator] = function () {
    return this;
  }), i;

  function c(i) {
    return function (c) {
      return function (i) {
        if (t) throw new TypeError("Generator is already executing.");

        for (; a;) {
          try {
            if (t = 1, n && (u = 2 & i[0] ? n.return : i[0] ? n.throw || ((u = n.return) && u.call(n), 0) : n.next) && !(u = u.call(n, i[1])).done) return u;

            switch (n = 0, u && (i = [2 & i[0], u.value]), i[0]) {
              case 0:
              case 1:
                u = i;
                break;

              case 4:
                return a.label++, {
                  value: i[1],
                  done: !1
                };

              case 5:
                a.label++, n = i[1], i = [0];
                continue;

              case 7:
                i = a.ops.pop(), a.trys.pop();
                continue;

              default:
                if (!(u = a.trys, (u = u.length > 0 && u[u.length - 1]) || 6 !== i[0] && 2 !== i[0])) {
                  a = 0;
                  continue;
                }

                if (3 === i[0] && (!u || i[1] > u[0] && i[1] < u[3])) {
                  a.label = i[1];
                  break;
                }

                if (6 === i[0] && a.label < u[1]) {
                  a.label = u[1], u = i;
                  break;
                }

                if (u && a.label < u[2]) {
                  a.label = u[2], a.ops.push(i);
                  break;
                }

                u[2] && a.ops.pop(), a.trys.pop();
                continue;
            }

            i = e.call(r, a);
          } catch (r) {
            i = [6, r], n = 0;
          } finally {
            t = u = 0;
          }
        }

        if (5 & i[0]) throw i[1];
        return {
          value: i[0] ? i[1] : void 0,
          done: !0
        };
      }([i, c]);
    };
  }
}

function i(r) {
  var e = "function" == typeof Symbol && Symbol.iterator,
      t = e && r[e],
      n = 0;
  if (t) return t.call(r);
  if (r && "number" == typeof r.length) return {
    next: function next() {
      return r && n >= r.length && (r = void 0), {
        value: r && r[n++],
        done: !r
      };
    }
  };
  throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}

function a(r, e) {
  var t = "function" == typeof Symbol && r[Symbol.iterator];
  if (!t) return r;
  var n,
      u,
      i = t.call(r),
      a = [];

  try {
    for (; (void 0 === e || e-- > 0) && !(n = i.next()).done;) {
      a.push(n.value);
    }
  } catch (r) {
    u = {
      error: r
    };
  } finally {
    try {
      n && !n.done && (t = i.return) && t.call(i);
    } finally {
      if (u) throw u.error;
    }
  }

  return a;
}

function c() {
  for (var r = [], e = 0; e < arguments.length; e++) {
    r = r.concat(a(arguments[e]));
  }

  return r;
}

var o = function o(r) {
  return r instanceof HTMLElement;
},
    s = "blur",
    l = "change",
    f = "input",
    d = "onBlur",
    v = "onChange",
    y = "onSubmit",
    h = "onTouched",
    p = "all",
    m = "max",
    b = "min",
    g = "maxLength",
    A = "minLength",
    x = "pattern",
    R = "required",
    V = "validate";

var w = function w(r) {
  return null == r;
},
    F = function F(r) {
  return "object" == typeof r;
},
    C = function C(r) {
  return !w(r) && !Array.isArray(r) && F(r) && !(r instanceof Date);
},
    S = function S(r) {
  return /^\w*$/.test(r);
},
    k = function k(r) {
  return r.filter(Boolean);
},
    O = function O(r) {
  return k(r.replace(/["|']/g, "").replace(/\[/g, ".").replace(/\]/g, "").split("."));
};

function D(r, e, t) {
  for (var n = -1, u = S(e) ? [e] : O(e), i = u.length, a = i - 1; ++n < i;) {
    var c = u[n],
        o = t;

    if (n !== a) {
      var s = r[c];
      o = C(s) || Array.isArray(s) ? s : isNaN(+u[n + 1]) ? {} : [];
    }

    r[c] = o, r = r[c];
  }

  return r;
}

var E = function E(r, e) {
  for (var t in void 0 === e && (e = {}), r) {
    S(t) ? e[t] = r[t] : D(e, t, r[t]);
  }

  return e;
},
    j = function j(r) {
  return void 0 === r;
},
    B = function B(r, e, t) {
  void 0 === r && (r = {});
  var n = k(e.split(/[,[\].]+?/)).reduce(function (r, e) {
    return w(r) ? r : r[e];
  }, r);
  return j(n) || n === r ? j(r[e]) ? t : r[e] : n;
},
    N = function N(r, e) {
  o(r) && r.removeEventListener && (r.removeEventListener(f, e), r.removeEventListener(l, e), r.removeEventListener(s, e));
},
    T = {
  isValid: !1,
  value: null
},
    L = function L(r) {
  return Array.isArray(r) ? r.reduce(function (r, e) {
    return e && e.ref.checked ? {
      isValid: !0,
      value: e.ref.value
    } : r;
  }, T) : T;
},
    W = function W(r) {
  return "radio" === r.type;
},
    M = function M(r) {
  return "file" === r.type;
},
    P = function P(r) {
  return "checkbox" === r.type;
},
    U = function U(r) {
  return "select-multiple" === r.type;
},
    q = {
  value: !1,
  isValid: !1
},
    H = {
  value: !0,
  isValid: !0
},
    I = function I(r) {
  if (Array.isArray(r)) {
    if (r.length > 1) {
      var e = r.filter(function (r) {
        return r && r.ref.checked;
      }).map(function (r) {
        return r.ref.value;
      });
      return {
        value: e,
        isValid: !!e.length
      };
    }

    var t = r[0].ref,
        n = t.checked,
        u = t.value,
        i = t.attributes;
    return n ? i && !j(i.value) ? j(u) || "" === u ? H : {
      value: u,
      isValid: !0
    } : H : q;
  }

  return q;
};

function _(r, e, t, n, u) {
  var i = r.current[e];

  if (i) {
    var a = i.ref,
        o = a.value,
        s = a.disabled,
        l = i.ref,
        f = i.valueAsNumber,
        d = i.valueAsDate,
        v = i.setValueAs;
    if (s && n) return;
    return M(l) ? l.files : W(l) ? L(i.options).value : U(l) ? c(l.options).filter(function (r) {
      return r.selected;
    }).map(function (r) {
      return r.value;
    }) : P(l) ? I(i.options).value : u ? o : f ? "" === o ? NaN : +o : d ? l.valueAsDate : v ? v(o) : o;
  }

  if (t) return B(t.current, e);
}

function z(r) {
  return !r || r instanceof HTMLElement && r.nodeType !== Node.DOCUMENT_NODE && z(r.parentNode);
}

var G = function G(r) {
  return C(r) && !Object.keys(r).length;
},
    $ = function $(r) {
  return "boolean" == typeof r;
};

function J(r, e) {
  var t,
      n = S(e) ? [e] : O(e),
      u = 1 == n.length ? r : function (r, e) {
    for (var t = e.slice(0, -1).length, n = 0; n < t;) {
      r = j(r) ? n++ : r[e[n++]];
    }

    return r;
  }(r, n),
      i = n[n.length - 1];
  u && delete u[i];

  for (var a = 0; a < n.slice(0, -1).length; a++) {
    var c = -1,
        o = void 0,
        s = n.slice(0, -(a + 1)),
        l = s.length - 1;

    for (a > 0 && (t = r); ++c < s.length;) {
      var f = s[c];
      o = o ? o[f] : r[f], l === c && (C(o) && G(o) || Array.isArray(o) && !o.filter(function (r) {
        return C(r) && !G(r) || $(r);
      }).length) && (t ? delete t[f] : delete r[f]), t = o;
    }
  }

  return r;
}

var K = function K(r, e) {
  return r && r.ref === e;
};

var Q = function Q(r) {
  return w(r) || !F(r);
};

function X(r, e) {
  if (Q(r) || Q(e)) return e;

  for (var t in e) {
    var n = r[t],
        u = e[t];

    try {
      r[t] = C(n) && C(u) || Array.isArray(n) && Array.isArray(u) ? X(n, u) : u;
    } catch (r) {}
  }

  return r;
}

function Y(e, t, n) {
  var u, a;
  if (Q(e) || Q(t) || e instanceof Date || t instanceof Date) return e === t;

  if (!r.isValidElement(e)) {
    var c = Object.keys(e),
        o = Object.keys(t);
    if (c.length !== o.length) return !1;

    try {
      for (var s = i(c), l = s.next(); !l.done; l = s.next()) {
        var f = l.value,
            d = e[f];

        if (!n || "ref" !== f) {
          var v = t[f];
          if ((C(d) || Array.isArray(d)) && (C(v) || Array.isArray(v)) ? !Y(d, v, n) : d !== v) return !1;
        }
      }
    } catch (r) {
      u = {
        error: r
      };
    } finally {
      try {
        l && !l.done && (a = s.return) && a.call(s);
      } finally {
        if (u) throw u.error;
      }
    }
  }

  return !0;
}

function Z(r, t, n, u, i) {
  for (var a, c = -1; ++c < r.length;) {
    for (var o in r[c]) {
      Array.isArray(r[c][o]) ? (!n[c] && (n[c] = {}), n[c][o] = [], Z(r[c][o], B(t[c] || {}, o, []), n[c][o], n[c], o)) : Y(B(t[c] || {}, o), r[c][o]) ? D(n[c] || {}, o) : n[c] = _e(_e({}, n[c]), ((a = {})[o] = !0, a));
    }

    u && !n.length && delete u[i];
  }

  return n;
}

var rr = function rr(r, e, t) {
  return X(Z(r, e, t.slice(0, r.length)), Z(e, r, t.slice(0, r.length)));
},
    er = function er(r) {
  return "string" == typeof r;
},
    tr = function tr(r, e, t, n, u) {
  var i = {},
      a = function a(e) {
    (j(u) || (er(u) ? e.startsWith(u) : Array.isArray(u) && u.find(function (r) {
      return e.startsWith(r);
    }))) && (i[e] = _(r, e, void 0, n));
  };

  for (var c in r.current) {
    a(c);
  }

  return t ? E(i) : X(e, E(i));
},
    nr = function nr(r) {
  return r instanceof RegExp;
},
    ur = function ur(r) {
  return C(r) && !nr(r) ? r : {
    value: r,
    message: ""
  };
},
    ir = function ir(r) {
  return "function" == typeof r;
},
    ar = function ar(e) {
  return er(e) || r.isValidElement(e);
};

function cr(r, e, t) {
  if (void 0 === t && (t = "validate"), ar(r) || $(r) && !r) return {
    type: t,
    message: ar(r) ? r : "",
    ref: e
  };
}

var or = function or(r, t, n, u, i) {
  var a;
  return t ? _e(_e({}, n[r]), {
    types: _e(_e({}, n[r] && n[r].types ? n[r].types : {}), (a = {}, a[u] = i || !0, a))
  }) : {};
},
    sr = function sr(r, t, c, o) {
  var s = c.ref,
      l = c.ref.value,
      f = c.options,
      d = c.required,
      v = c.maxLength,
      y = c.minLength,
      h = c.min,
      p = c.max,
      F = c.pattern,
      S = c.validate;
  return n(void 0, void 0, void 0, function () {
    var n, c, k, O, D, E, j, B, N, T, M, U, q, H, z, J, K, Q, X, Y, Z, rr, tr, sr, lr, fr, dr, vr, yr, hr, pr, mr, br, gr, Ar;
    return u(this, function (u) {
      switch (u.label) {
        case 0:
          return n = s.name, c = {}, k = W(s), O = P(s), D = k || O, E = "" === l, j = or.bind(null, n, t, c), B = function B(r, t, u, i, a) {
            void 0 === i && (i = g), void 0 === a && (a = A);
            var o = r ? t : u;
            c[n] = _e({
              type: r ? i : a,
              message: o,
              ref: s
            }, j(r ? i : a, o));
          }, d && (!k && !O && (E || w(l)) || $(l) && !l || O && !I(f).isValid || k && !L(f).isValid) && (N = ar(d) ? {
            value: !!d,
            message: d
          } : ur(d), T = N.value, Z = N.message, T && (c[n] = _e({
            type: R,
            message: Z,
            ref: D ? ((r.current[n].options || [])[0] || {}).ref : s
          }, j(R, Z)), !t)) ? [2, c] : (w(h) && w(p) || "" === l || (K = void 0, Q = void 0, M = ur(p), U = ur(h), isNaN(l) ? (H = s.valueAsDate || new Date(l), er(M.value) && (K = H > new Date(M.value)), er(U.value) && (Q = H < new Date(U.value))) : (q = s.valueAsNumber || parseFloat(l), w(M.value) || (K = q > M.value), w(U.value) || (Q = q < U.value)), !K && !Q || (B(!!K, M.message, U.message, m, b), t))) && (!er(l) || E || !v && !y || (z = ur(v), J = ur(y), K = !w(z.value) && l.length > z.value, Q = !w(J.value) && l.length < J.value, !K && !Q || (B(K, z.message, J.message), t))) ? er(l) && F && !E && (X = ur(F), Y = X.value, Z = X.message, nr(Y) && !Y.test(l) && (c[n] = _e({
            type: x,
            message: Z,
            ref: s
          }, j(x, Z)), !t)) ? [2, c] : S ? (rr = _(r, n, o, !1, !0), tr = D && f ? f[0].ref : s, ir(S) ? [4, S(rr)] : [3, 2]) : [3, 11] : [2, c];

        case 1:
          return sr = u.sent(), (mr = cr(sr, tr)) && (c[n] = _e(_e({}, mr), j(V, mr.message)), !t) ? [2, c] : [3, 11];

        case 2:
          if (!C(S)) return [3, 11];
          lr = {}, u.label = 3;

        case 3:
          u.trys.push([3, 8, 9, 10]), fr = i(Object.entries(S)), dr = fr.next(), u.label = 4;

        case 4:
          return dr.done ? [3, 7] : (vr = a(dr.value, 2), yr = vr[0], hr = vr[1], G(lr) || t ? [4, hr(rr)] : [3, 7]);

        case 5:
          pr = u.sent(), (mr = cr(pr, tr, yr)) && (lr = _e(_e({}, mr), j(yr, mr.message)), t && (c[n] = lr)), u.label = 6;

        case 6:
          return dr = fr.next(), [3, 4];

        case 7:
          return [3, 10];

        case 8:
          return br = u.sent(), gr = {
            error: br
          }, [3, 10];

        case 9:
          try {
            dr && !dr.done && (Ar = fr.return) && Ar.call(fr);
          } finally {
            if (gr) throw gr.error;
          }

          return [7];

        case 10:
          if (!G(lr) && (c[n] = _e({
            ref: tr
          }, lr), !t)) return [2, c];
          u.label = 11;

        case 11:
          return [2, c];
      }
    });
  });
},
    lr = function lr(r, e, t) {
  for (var n in void 0 === t && (t = []), e) {
    var u = r + (C(e) ? "." + n : "[" + n + "]");
    Q(e[n]) ? t.push(u) : lr(u, e[n], t);
  }

  return t;
},
    fr = function fr(r, e, t, n, u) {
  var i = void 0;
  return t.add(e), G(r) || (i = B(r, e), (C(i) || Array.isArray(i)) && lr(e, i).forEach(function (r) {
    return t.add(r);
  })), j(i) ? u ? n : B(n, e) : i;
},
    dr = function dr(r) {
  var e = r.isOnBlur,
      t = r.isOnChange,
      n = r.isOnTouch,
      u = r.isTouched,
      i = r.isReValidateOnBlur,
      a = r.isReValidateOnChange,
      c = r.isBlurEvent,
      o = r.isSubmitted;
  return !r.isOnAll && (!o && n ? !(u || c) : (o ? i : e) ? !c : !(o ? a : t) || c);
},
    vr = function vr(r) {
  return r.substring(0, r.indexOf("["));
},
    yr = function yr(r, e) {
  return RegExp(("^" + e + "([|.)\\d+").replace(/\[/g, "\\[").replace(/\]/g, "\\]")).test(r);
},
    hr = function hr(r, e) {
  return c(r).some(function (r) {
    return yr(e, r);
  });
};

var pr = "undefined" != typeof window && "undefined" != typeof document;

function mr(r) {
  var e, t, n, u, a, c;
  if (Q(r) || pr && (r instanceof File || o(r))) return r;
  if (!["Set", "Map", "Object", "Date", "Array"].includes(null === (a = r.constructor) || void 0 === a ? void 0 : a.name)) return r;
  if (r instanceof Date) return c = new Date(r.getTime());

  if (r instanceof Set) {
    c = new Set();

    try {
      for (var s = i(r), l = s.next(); !l.done; l = s.next()) {
        var f = l.value;
        c.add(f);
      }
    } catch (r) {
      e = {
        error: r
      };
    } finally {
      try {
        l && !l.done && (t = s.return) && t.call(s);
      } finally {
        if (e) throw e.error;
      }
    }

    return c;
  }

  if (r instanceof Map) {
    c = new Map();

    try {
      for (var d = i(r.keys()), v = d.next(); !v.done; v = d.next()) {
        var y = v.value;
        c.set(y, mr(r.get(y)));
      }
    } catch (r) {
      n = {
        error: r
      };
    } finally {
      try {
        v && !v.done && (u = d.return) && u.call(d);
      } finally {
        if (n) throw n.error;
      }
    }

    return c;
  }

  for (var y in c = Array.isArray(r) ? [] : {}, r) {
    c[y] = mr(r[y]);
  }

  return c;
}

var br = function br(r) {
  return {
    isOnSubmit: !r || r === y,
    isOnBlur: r === d,
    isOnChange: r === v,
    isOnAll: r === p,
    isOnTouch: r === h
  };
},
    gr = function gr(r) {
  return W(r) || P(r);
},
    Ar = "undefined" == typeof window,
    xr = pr ? "Proxy" in window : "undefined" != typeof Proxy;

var Rr = r.createContext(null);
Rr.displayName = "RHFContext";

var Vr = function Vr() {
  return r.useContext(Rr);
},
    wr = function wr() {
  var r = "undefined" == typeof performance ? Date.now() : 1e3 * performance.now();
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (e) {
    var t = (16 * Math.random() + r) % 16 | 0;
    return ("x" == e ? t : 3 & t | 8).toString(16);
  });
};

var Fr = function Fr(r, e) {
  return j(e) ? [] : function (r, e) {
    var t,
        n,
        u = 0,
        a = c(r);

    try {
      for (var o = i(e), s = o.next(); !s.done; s = o.next()) {
        var l = s.value;
        a.splice(l - u, 1), u++;
      }
    } catch (r) {
      t = {
        error: r
      };
    } finally {
      try {
        s && !s.done && (n = o.return) && n.call(o);
      } finally {
        if (t) throw t.error;
      }
    }

    return k(a).length ? a : [];
  }(r, (Array.isArray(e) ? e : [e]).sort(function (r, e) {
    return r - e;
  }));
},
    Cr = function Cr(r, e, t) {
  return Array.isArray(r) ? (j(r[t]) && (r[t] = void 0), r.splice(t, 0, r.splice(e, 1)[0]), r) : [];
},
    Sr = function Sr(r, e, t) {
  var n = [r[t], r[e]];
  r[e] = n[0], r[t] = n[1];
};

function kr(r, e) {
  return c(Array.isArray(e) ? e : [e || void 0], r);
}

function Or(r, e, t) {
  return c(r.slice(0, e), Array.isArray(t) ? t : [t || void 0], r.slice(e));
}

var Dr = function Dr(r) {
  return Array.isArray(r) ? Array(r.length).fill(void 0) : void 0;
},
    Er = function Er(r) {
  return (Array.isArray(r) ? r : [r]).map(function (r) {
    if (C(r)) {
      var e = {};

      for (var t in r) {
        e[t] = !0;
      }

      return e;
    }

    return !0;
  });
},
    jr = function jr(r, t, n) {
  return void 0 === r && (r = []), r.map(function (r) {
    var n;
    return _e(((n = {})[t] = r[t] || wr(), n), r);
  });
};

function Br(t) {
  var n = t.name,
      u = t.rules,
      i = t.defaultValue,
      c = t.control,
      o = t.onFocus,
      s = Vr(),
      l = c || s.control,
      f = l.defaultValuesRef,
      d = l.setValue,
      v = l.register,
      y = l.unregister,
      h = l.trigger,
      p = l.mode,
      m = l.reValidateMode,
      b = m.isReValidateOnBlur,
      g = m.isReValidateOnChange,
      A = l.formState,
      x = l.formStateRef.current,
      R = x.isSubmitted,
      V = x.touched,
      w = x.errors,
      F = l.updateFormState,
      S = l.readFormStateRef,
      k = l.fieldsRef,
      O = l.fieldArrayNamesRef,
      E = l.shallowFieldsStateRef,
      N = !hr(O.current, n),
      T = function T() {
    return !j(B(E.current, n)) && N ? B(E.current, n) : j(i) ? B(f.current, n) : i;
  },
      L = a(r.useState(T()), 2),
      W = L[0],
      M = L[1],
      P = r.useRef(W),
      U = r.useRef({
    focus: function focus() {
      return null;
    }
  }),
      q = r.useRef(o || function () {
    ir(U.current.focus) && U.current.focus();
  }),
      H = r.useCallback(function (r) {
    return !dr(_e({
      isBlurEvent: r,
      isReValidateOnBlur: b,
      isReValidateOnChange: g,
      isSubmitted: R,
      isTouched: !!B(V, n)
    }, p));
  }, [b, g, R, V, n, p]),
      I = r.useCallback(function (r) {
    var e = function (r) {
      return Q(r) || !C(r.target) || C(r.target) && !r.type ? r : j(r.target.value) ? r.target.checked : r.target.value;
    }(a(r, 1)[0]);

    return M(e), P.current = e, e;
  }, []),
      _ = r.useCallback(function (r) {
    k.current[n] ? k.current[n] = _e({
      ref: k.current[n].ref
    }, u) : (v(Object.defineProperties({
      name: n,
      focus: q.current
    }, {
      value: {
        set: function set(r) {
          M(r), P.current = r;
        },
        get: function get() {
          return P.current;
        }
      }
    }), u), r = j(B(f.current, n))), r && N && M(T());
  }, [u, n, v]);

  r.useEffect(function () {
    return function () {
      return y(n);
    };
  }, [n]), r.useEffect(function () {
    _();
  }, [_]), r.useEffect(function () {
    !k.current[n] && _(!0);
  });
  var z = r.useCallback(function () {
    S.current.touched && !B(V, n) && (D(V, n, !0), F({
      touched: V
    })), H(!0) && h(n);
  }, [n, F, H, h, S]);
  return {
    field: {
      onChange: r.useCallback(function () {
        for (var r = [], e = 0; e < arguments.length; e++) {
          r[e] = arguments[e];
        }

        return d(n, I(r), {
          shouldValidate: H(),
          shouldDirty: !0
        });
      }, [d, n, H]),
      onBlur: z,
      name: n,
      value: W,
      ref: U
    },
    meta: Object.defineProperties({
      invalid: !!B(w, n)
    }, {
      isDirty: {
        get: function get() {
          return !!B(A.dirtyFields, n);
        }
      },
      isTouched: {
        get: function get() {
          return !!B(A.touched, n);
        }
      }
    })
  };
}

exports.Controller = function (n) {
  n.rules;

  var u = n.as,
      i = n.render,
      a = (n.defaultValue, n.control, n.onFocus, t(n, ["rules", "as", "render", "defaultValue", "control", "onFocus"])),
      c = Br(n),
      o = c.field,
      s = c.meta,
      l = _e(_e({}, a), o);

  return u ? r.isValidElement(u) ? r.cloneElement(u, l) : r.createElement(u, l) : i ? i(o, s) : null;
}, exports.FormProvider = function (n) {
  var u = n.children,
      i = t(n, ["children"]);
  return r.createElement(Rr.Provider, {
    value: _e({}, i)
  }, u);
}, exports.appendErrors = or, exports.get = B, exports.transformToNestObject = E, exports.useController = Br, exports.useFieldArray = function (n) {
  var u = n.control,
      i = n.name,
      o = n.keyName,
      s = void 0 === o ? "id" : o,
      l = Vr(),
      f = r.useRef(-1),
      d = r.useRef(!1),
      v = u || l.control,
      y = v.isFormDirty,
      h = v.updateWatchedValue,
      p = v.resetFieldArrayFunctionRef,
      m = v.fieldArrayNamesRef,
      b = v.fieldsRef,
      g = v.defaultValuesRef,
      A = v.removeFieldEventListener,
      x = v.formStateRef,
      R = v.shallowFieldsStateRef,
      V = v.updateFormState,
      w = v.readFormStateRef,
      F = v.validFieldsRef,
      C = v.fieldsWithValidationRef,
      S = v.fieldArrayDefaultValuesRef,
      O = v.validateResolver,
      E = v.getValues,
      j = v.shouldUnregister,
      N = v.fieldArrayValuesRef,
      T = function T(r) {
    return B(j ? r : R.current, i, []);
  },
      L = vr(i),
      W = r.useRef(c(B(S.current, L) ? T(S.current) : T(g.current))),
      M = a(r.useState(jr(W.current, s)), 2),
      P = M[0],
      U = M[1];

  D(N.current, i, P);

  var q = function q(r) {
    return r.map(function (r) {
      void 0 === r && (r = {});
      var e = s;
      r[e];
      return t(r, ["symbol" == typeof e ? e : e + ""]);
    });
  };

  m.current.add(i);

  var H = r.useCallback(function () {
    return B(N.current, i, []);
  }, [i]),
      I = function I() {
    return jr(B(E(), i, H()).map(function (r, t) {
      return _e(_e({}, H()[t]), r);
    }), s);
  };

  m.current.add(i), L && !B(S.current, L) && D(S.current, L, mr(B(g.current, L)));

  var _ = function _(r) {
    if (U(r), D(N.current, i, r), w.current.isValid && O) {
      var e = E();
      D(e, i, r), O(e);
    }
  },
      z = function z() {
    for (var r in b.current) {
      yr(r, i) && (A(b.current[r], !0), delete b.current[r]);
    }
  },
      G = function G(r) {
    return !k(B(r, i, [])).length && J(r, i);
  },
      $ = function $(r) {
    r && D(x.current.dirtyFields, i, rr(q(r), B(g.current, i, []), B(x.current.dirtyFields, i, [])));
  },
      K = function K(r, e, t, n, u, a) {
    if (void 0 === n && (n = []), void 0 === u && (u = !0), void 0 === a && (a = !1), B(R.current, i)) {
      var c = r(B(R.current, i), e.argA, e.argB);
      u && D(R.current, i, c);
    }

    if (B(S.current, i)) {
      c = r(B(S.current, i), e.argA, e.argB);
      u && D(S.current, i, c);
    }

    if (Array.isArray(B(x.current.errors, i))) {
      c = r(B(x.current.errors, i), e.argA, e.argB);
      u && D(x.current.errors, i, c), G(x.current.errors);
    }

    if (w.current.touched && B(x.current.touched, i)) {
      c = r(B(x.current.touched, i), e.argA, e.argB);
      u && D(x.current.touched, i, c), G(x.current.touched);
    }

    (w.current.dirtyFields || w.current.isDirty) && (D(x.current.dirtyFields, i, rr(q(n), B(g.current, i, []), B(x.current.dirtyFields, i, []))), $(t), G(x.current.dirtyFields)), a && w.current.isValid && !O && (D(F.current, i, r(B(F.current, i, []), e.argA)), G(F.current), D(C.current, i, r(B(C.current, i, []), e.argA)), G(C.current)), !d.current && w.current.isDirty && V({
      isDirty: y(i, q(n))
    });
  },
      Q = function Q(r) {
    var e = I(),
        t = Fr(e, r);
    _(t), z(), K(Fr, {
      argA: r,
      argC: r
    }, t, Fr(e, r), !0, !0);
  };

  return r.useEffect(function () {
    var r = B(S.current, i);
    if (r && P.length < r.length && D(S.current, i, r.slice(1)), h(i), f.current > -1) for (var e in b.current) {
      var t = b.current[e];

      if (e.startsWith(i + "[" + f.current + "]") && t.ref.focus) {
        t.ref.focus();
        break;
      }
    }
    f.current = -1;
  }, [P, i]), r.useEffect(function () {
    var r = p.current,
        e = m.current;
    return vr(i) || (r[i] = function (r) {
      z(), !r && J(S.current, i), J(R.current, i), W.current = B(r || g.current, i), d.current || U(jr(W.current, s));
    }), function () {
      d.current = !0, j && Q(), z(), delete r[i], J(N.current, i), e.delete(i);
    };
  }, []), {
    swap: r.useCallback(function (r, e) {
      var t = I();
      Sr(t, r, e), z(), _(c(t)), K(Sr, {
        argA: r,
        argB: e,
        argC: r,
        argD: e
      }, void 0, t, !1);
    }, [i]),
    move: r.useCallback(function (r, e) {
      var t = I();
      Cr(t, r, e), z(), _(c(t)), K(Cr, {
        argA: r,
        argB: e,
        argC: r,
        argD: e
      }, void 0, t, !1);
    }, [i]),
    prepend: r.useCallback(function (r, e) {
      void 0 === e && (e = !0);
      var t = Dr(r),
          n = kr(I(), jr(Array.isArray(r) ? r : [r], s));
      _(n), z(), K(kr, {
        argA: t,
        argC: Er(r)
      }, n), f.current = e ? 0 : -1;
    }, [i]),
    append: r.useCallback(function (r, e) {
      void 0 === e && (e = !0);
      var t = Array.isArray(r) ? r : [r],
          n = c(I(), jr(t, s));
      _(n), (w.current.dirtyFields || w.current.isDirty) && ($(n), V({
        isDirty: !0,
        dirtyFields: x.current.dirtyFields
      })), !j && D(R.current, i, c(B(R.current, i) || [], mr(t))), f.current = e ? B(N.current, i).length - 1 : -1;
    }, [i]),
    remove: r.useCallback(Q, [i]),
    insert: r.useCallback(function (r, e, t) {
      void 0 === t && (t = !0);
      var n = Dr(e),
          u = I(),
          i = Or(u, r, jr(Array.isArray(e) ? e : [e], s));
      _(i), z(), K(Or, {
        argA: r,
        argB: n,
        argC: r,
        argD: Er(e)
      }, i, Or(u, r)), f.current = t ? r : -1;
    }, [i]),
    fields: k(P)
  };
}, exports.useForm = function (t) {
  var d = this,
      h = void 0 === t ? {} : t,
      m = h.mode,
      b = void 0 === m ? y : m,
      g = h.reValidateMode,
      A = void 0 === g ? v : g,
      x = h.resolver,
      R = h.context,
      V = h.defaultValues,
      F = void 0 === V ? {} : V,
      O = h.shouldFocusError,
      T = void 0 === O || O,
      L = h.shouldUnregister,
      q = void 0 === L || L,
      H = h.criteriaMode,
      I = r.useRef({}),
      $ = r.useRef({}),
      X = r.useRef({}),
      Z = r.useRef(new Set()),
      nr = r.useRef({}),
      ur = r.useRef({}),
      ar = r.useRef({}),
      cr = r.useRef({}),
      or = r.useRef(F),
      yr = r.useRef(!1),
      Rr = r.useRef(!1),
      Vr = r.useRef(),
      wr = r.useRef({}),
      Fr = r.useRef({}),
      Cr = r.useRef(R),
      Sr = r.useRef(x),
      kr = r.useRef(new Set()),
      Or = r.useRef(br(b)),
      Dr = Or.current,
      Er = Dr.isOnSubmit,
      jr = Dr.isOnTouch,
      Br = H === p,
      Nr = a(r.useState({
    isDirty: !1,
    isValidating: !1,
    dirtyFields: {},
    isSubmitted: !1,
    submitCount: 0,
    touched: {},
    isSubmitting: !1,
    isSubmitSuccessful: !1,
    isValid: !Er,
    errors: {}
  }), 2),
      Tr = Nr[0],
      Lr = Nr[1],
      Wr = r.useRef({
    isDirty: !xr,
    dirtyFields: !xr,
    touched: !xr || jr,
    isValidating: !xr,
    isSubmitting: !xr,
    isValid: !xr
  }),
      Mr = r.useRef(Tr),
      Pr = r.useRef(),
      Ur = r.useRef(br(A)).current,
      qr = Ur.isOnBlur,
      Hr = Ur.isOnChange;
  Cr.current = R, Sr.current = x, Mr.current = Tr, wr.current = q ? {} : G(wr.current) ? mr(F) : wr.current;

  var Ir = r.useCallback(function (r) {
    void 0 === r && (r = {}), yr.current || (Mr.current = _e(_e({}, Mr.current), r), Lr(Mr.current));
  }, []),
      _r = function _r() {
    return Wr.current.isValidating && Ir({
      isValidating: !0
    });
  },
      zr = r.useCallback(function (r, t, n, u, i) {
    void 0 === n && (n = !1), void 0 === u && (u = {});

    var a = n || function (r) {
      var e = r.errors,
          t = r.name,
          n = r.error,
          u = r.validFields,
          i = r.fieldsWithValidation,
          a = j(n),
          c = B(e, t);
      return a && !!c || !a && !Y(c, n, !0) || a && B(i, t) && !B(u, t);
    }({
      errors: Mr.current.errors,
      error: t,
      name: r,
      validFields: cr.current,
      fieldsWithValidation: ar.current
    }),
        c = B(Mr.current.errors, r);

    t ? (J(cr.current, r), a = a || !c || !Y(c, t, !0), D(Mr.current.errors, r, t)) : ((B(ar.current, r) || Sr.current) && (D(cr.current, r, !0), a = a || c), J(Mr.current.errors, r)), (a && !w(n) || !G(u) || Wr.current.isValidating) && Ir(_e(_e(_e({}, u), Sr.current ? {
      isValid: !!i
    } : {}), {
      isValidating: !1
    }));
  }, []),
      Gr = r.useCallback(function (r, e) {
    var t = I.current[r],
        n = t.ref,
        u = t.options,
        i = pr && o(n) && w(e) ? "" : e;
    W(n) ? (u || []).forEach(function (r) {
      var e = r.ref;
      return e.checked = e.value === i;
    }) : M(n) && !er(i) ? n.files = i : U(n) ? c(n.options).forEach(function (r) {
      return r.selected = i.includes(r.value);
    }) : P(n) && u ? u.length > 1 ? u.forEach(function (r) {
      var e = r.ref;
      return e.checked = Array.isArray(i) ? !!i.find(function (r) {
        return r === e.value;
      }) : i === e.value;
    }) : u[0].ref.checked = !!i : n.value = i;
  }, []),
      $r = r.useCallback(function (r, e) {
    if (Wr.current.isDirty) {
      var t = ne();
      return r && e && D(t, r, e), !Y(t, or.current);
    }

    return !1;
  }, []),
      Jr = r.useCallback(function (r, e) {
    if (void 0 === e && (e = !0), Wr.current.isDirty || Wr.current.dirtyFields) {
      var t = !Y(B(or.current, r), _(I, r, wr)),
          n = B(Mr.current.dirtyFields, r),
          u = Mr.current.isDirty;
      t ? D(Mr.current.dirtyFields, r, !0) : J(Mr.current.dirtyFields, r);
      var i = {
        isDirty: $r(),
        dirtyFields: Mr.current.dirtyFields
      },
          a = Wr.current.isDirty && u !== i.isDirty || Wr.current.dirtyFields && n !== B(Mr.current.dirtyFields, r);
      return a && e && Ir(i), a ? i : {};
    }

    return {};
  }, []),
      Kr = r.useCallback(function (r, e) {
    return n(d, void 0, void 0, function () {
      var t;
      return u(this, function (n) {
        switch (n.label) {
          case 0:
            return [4, sr(I, Br, I.current[r], wr)];

          case 1:
            return t = n.sent()[r], zr(r, t, e), [2, j(t)];
        }
      });
    });
  }, [zr, Br]),
      Qr = r.useCallback(function (r) {
    return n(d, void 0, void 0, function () {
      var e, t, n, i;
      return u(this, function (u) {
        switch (u.label) {
          case 0:
            return [4, Sr.current(ne(), Cr.current, Br)];

          case 1:
            return e = u.sent().errors, t = Mr.current.isValid, Array.isArray(r) ? (n = r.map(function (r) {
              var t = B(e, r);
              return t ? D(Mr.current.errors, r, t) : J(Mr.current.errors, r), !t;
            }).every(Boolean), Ir({
              isValid: G(e),
              isValidating: !1
            }), [2, n]) : (i = B(e, r), zr(r, i, t !== G(e), {}, G(e)), [2, !i]);
        }
      });
    });
  }, [zr, Br]),
      Xr = r.useCallback(function (r) {
    return n(d, void 0, void 0, function () {
      var e,
          t,
          i = this;
      return u(this, function (a) {
        switch (a.label) {
          case 0:
            return e = r || Object.keys(I.current), _r(), Sr.current ? [2, Qr(e)] : Array.isArray(e) ? (!r && (Mr.current.errors = {}), [4, Promise.all(e.map(function (r) {
              return n(i, void 0, void 0, function () {
                return u(this, function (e) {
                  switch (e.label) {
                    case 0:
                      return [4, Kr(r, null)];

                    case 1:
                      return [2, e.sent()];
                  }
                });
              });
            }))]) : [3, 2];

          case 1:
            return t = a.sent(), Ir({
              isValidating: !1
            }), [2, t.every(Boolean)];

          case 2:
            return [4, Kr(e)];

          case 3:
            return [2, a.sent()];
        }
      });
    });
  }, [Qr, Kr]),
      Yr = r.useCallback(function (r, e, t) {
    var n,
        u,
        a = t.shouldDirty,
        c = t.shouldValidate,
        o = {};
    D(o, r, e);

    try {
      for (var s = i(lr(r, e)), l = s.next(); !l.done; l = s.next()) {
        var f = l.value;
        I.current[f] && (Gr(f, B(o, f)), a && Jr(f), c && Xr(f));
      }
    } catch (r) {
      n = {
        error: r
      };
    } finally {
      try {
        l && !l.done && (u = s.return) && u.call(s);
      } finally {
        if (n) throw n.error;
      }
    }
  }, [Xr, Gr, Jr]),
      Zr = r.useCallback(function (r, t, n) {
    var u, i;
    if (!q && !Q(t) && D(wr.current, r, Array.isArray(t) ? c(t) : _e({}, t)), I.current[r]) Gr(r, t), n.shouldDirty && Jr(r), n.shouldValidate && Xr(r);else if (!Q(t) && (Yr(r, t, n), kr.current.has(r))) {
      var a = vr(r) || r;
      D($.current, r, t), Fr.current[a](((u = {})[a] = B($.current, a), u)), (Wr.current.isDirty || Wr.current.dirtyFields) && n.shouldDirty && (D(Mr.current.dirtyFields, r, rr(t, B(or.current, r, []), B(Mr.current.dirtyFields, r, []))), Ir({
        isDirty: !Y(_e(_e({}, ne()), (i = {}, i[r] = t, i)), or.current)
      }));
    }
    !q && D(wr.current, r, t);
  }, [Jr, Gr, Yr]),
      re = function re(r) {
    return Rr.current || Z.current.has(r) || Z.current.has((r.match(/\w+/) || [])[0]);
  },
      ee = function ee(r) {
    var e = !0;
    if (!G(nr.current)) for (var t in nr.current) {
      r && nr.current[t].size && !nr.current[t].has(r) && !nr.current[t].has(vr(r)) || (ur.current[t](), e = !1);
    }
    return e;
  };

  function te(r) {
    var t, n, u;

    if (!q) {
      var a = mr(r);

      try {
        for (var c = i(kr.current), o = c.next(); !o.done; o = c.next()) {
          var s = o.value;
          S(s) && !a[s] && (a = _e(_e({}, a), ((u = {})[s] = [], u)));
        }
      } catch (r) {
        t = {
          error: r
        };
      } finally {
        try {
          o && !o.done && (n = c.return) && n.call(c);
        } finally {
          if (t) throw t.error;
        }
      }

      return a;
    }

    return r;
  }

  function ne(r) {
    var e, t;
    if (er(r)) return _(I, r, wr);

    if (Array.isArray(r)) {
      var n = {};

      try {
        for (var u = i(r), a = u.next(); !a.done; a = u.next()) {
          var c = a.value;
          D(n, c, _(I, c, wr));
        }
      } catch (r) {
        e = {
          error: r
        };
      } finally {
        try {
          a && !a.done && (t = u.return) && t.call(u);
        } finally {
          if (e) throw e.error;
        }
      }

      return n;
    }

    return te(tr(I, mr(wr.current), q));
  }

  Vr.current = Vr.current ? Vr.current : function (r) {
    var t = r.type,
        i = r.target;
    return n(d, void 0, void 0, function () {
      var r, n, a, c, o, l, f, d, v, y, h, p;
      return u(this, function (u) {
        switch (u.label) {
          case 0:
            return r = i.name, (n = I.current[r]) ? (l = dr(_e({
              isBlurEvent: o = t === s,
              isReValidateOnChange: Hr,
              isReValidateOnBlur: qr,
              isTouched: !!B(Mr.current.touched, r),
              isSubmitted: Mr.current.isSubmitted
            }, Or.current)), f = Jr(r, !1), d = !G(f) || !o && re(r), o && !B(Mr.current.touched, r) && Wr.current.touched && (D(Mr.current.touched, r, !0), f = _e(_e({}, f), {
              touched: Mr.current.touched
            })), !q && P(i) && D(wr.current, r, _(I, r)), l ? (!o && ee(r), [2, (!G(f) || d && G(f)) && Ir(f)]) : (_r(), Sr.current ? [4, Sr.current(ne(), Cr.current, Br)] : [3, 2])) : [3, 5];

          case 1:
            return v = u.sent().errors, y = Mr.current.isValid, a = B(v, r), P(i) && !a && Sr.current && (h = vr(r), (p = B(v, h, {})).type && p.message && (a = p), h && (p || B(Mr.current.errors, h)) && (r = h)), c = G(v), y !== c && (d = !0), [3, 4];

          case 2:
            return [4, sr(I, Br, n, wr)];

          case 3:
            a = u.sent()[r], u.label = 4;

          case 4:
            !o && ee(r), zr(r, a, d, f, c), u.label = 5;

          case 5:
            return [2];
        }
      });
    });
  };
  var ue = r.useCallback(function (r) {
    return void 0 === r && (r = {}), n(d, void 0, void 0, function () {
      var t, n, i;
      return u(this, function (u) {
        switch (u.label) {
          case 0:
            return t = G(I.current) ? or.current : {}, [4, Sr.current(_e(_e(_e({}, t), ne()), r), Cr.current, Br)];

          case 1:
            return n = (u.sent() || {}).errors, i = G(n), Mr.current.isValid !== i && Ir({
              isValid: i
            }), [2];
        }
      });
    });
  }, [Br]),
      ie = r.useCallback(function (r, e) {
    !function (r, e, t, n, u, i) {
      var a = t.ref,
          c = t.ref.name,
          o = r.current[c];

      if (!u) {
        var s = _(r, c, n);

        !j(s) && D(n.current, c, s);
      }

      a.type && o ? W(a) || P(a) ? Array.isArray(o.options) && o.options.length ? (k(o.options).forEach(function (r, t) {
        void 0 === r && (r = {}), (z(r.ref) && K(r, r.ref) || i) && (N(r.ref, e), J(o.options, "[" + t + "]"));
      }), o.options && !k(o.options).length && delete r.current[c]) : delete r.current[c] : (z(a) && K(o, a) || i) && (N(a, e), delete r.current[c]) : delete r.current[c];
    }(I, Vr.current, r, wr, q, e), q && (J(cr.current, r.ref.name), J(ar.current, r.ref.name));
  }, [q]),
      ae = r.useCallback(function (r) {
    var e, t;
    if (Rr.current) Ir();else {
      try {
        for (var n = i(Z.current), u = n.next(); !u.done; u = n.next()) {
          if (u.value.startsWith(r)) {
            Ir();
            break;
          }
        }
      } catch (r) {
        e = {
          error: r
        };
      } finally {
        try {
          u && !u.done && (t = n.return) && t.call(n);
        } finally {
          if (e) throw e.error;
        }
      }

      ee(r);
    }
  }, []),
      ce = r.useCallback(function (r, e) {
    r && (ie(r, e), q && !k(r.options || []).length && (J(Mr.current.errors, r.ref.name), D(Mr.current.dirtyFields, r.ref.name, !0), Ir({
      isDirty: $r()
    }), Wr.current.isValid && Sr.current && ue(), ae(r.ref.name)));
  }, [ue, ie]),
      oe = r.useCallback(function (r, t, n) {
    var u = n ? nr.current[n] : Z.current,
        i = tr(I, mr(wr.current), q, !1, r);

    if (er(r)) {
      var a = vr(r) || r;
      return kr.current.has(a) && (i = _e(_e({}, X.current), i)), fr(i, r, u, j(B(or.current, r)) ? t : B(or.current, r), !0);
    }

    var c = j(t) ? or.current : t;
    return Array.isArray(r) ? r.reduce(function (r, t) {
      var n;
      return _e(_e({}, r), ((n = {})[t] = fr(i, t, u, c), n));
    }, {}) : (Rr.current = j(n), E(!G(i) && i || c));
  }, []);

  function se(r, t) {
    void 0 === t && (t = {});

    var n,
        u = r.name,
        i = r.type,
        a = r.value,
        d = _e({
      ref: r
    }, t),
        v = I.current,
        y = gr(r),
        h = hr(kr.current, u),
        p = function p(e) {
      return pr && (!o(r) || e === r);
    },
        m = v[u],
        b = !0;

    if (m && (y ? Array.isArray(m.options) && k(m.options).find(function (r) {
      return a === r.ref.value && p(r.ref);
    }) : p(m.ref))) v[u] = _e(_e({}, m), t);else {
      m = i ? y ? _e({
        options: c(k(m && m.options || []), [{
          ref: r
        }]),
        ref: {
          type: i,
          name: u
        }
      }, t) : _e({}, d) : d, v[u] = m;
      var g = j(B(wr.current, u));
      G(or.current) && g || (n = B(g ? or.current : wr.current, u), (b = j(n)) || h || Gr(u, n)), G(t) || (D(ar.current, u, !0), !Er && Wr.current.isValid && sr(I, Br, m, wr).then(function (r) {
        var e = Mr.current.isValid;
        G(r) ? D(cr.current, u, !0) : J(cr.current, u), e !== G(r) && Ir();
      })), !q || h && b || !h && J(Mr.current.dirtyFields, u), i && function (r, e, t) {
        var n = r.ref;
        o(n) && t && (n.addEventListener(e ? l : f, t), n.addEventListener(s, t));
      }(y && m.options ? m.options[m.options.length - 1] : m, y || "select-one" === r.type, Vr.current);
    }
  }

  var le = r.useCallback(function (r, t) {
    return function (a) {
      return n(d, void 0, void 0, function () {
        var n, c, o, s, l, f, d, v, y, h, p, m, b;
        return u(this, function (u) {
          switch (u.label) {
            case 0:
              a && a.preventDefault && (a.preventDefault(), a.persist()), n = {}, c = te(tr(I, mr(wr.current), q, !0)), Wr.current.isSubmitting && Ir({
                isSubmitting: !0
              }), u.label = 1;

            case 1:
              return u.trys.push([1,, 16, 17]), Sr.current ? [4, Sr.current(c, Cr.current, Br)] : [3, 3];

            case 2:
              return o = u.sent(), s = o.errors, l = o.values, Mr.current.errors = n = s, c = l, [3, 10];

            case 3:
              u.trys.push([3, 8, 9, 10]), f = i(Object.values(I.current)), d = f.next(), u.label = 4;

            case 4:
              return d.done ? [3, 7] : (v = d.value) ? (y = v.ref.name, [4, sr(I, Br, v, wr)]) : [3, 6];

            case 5:
              (h = u.sent())[y] ? (D(n, y, h[y]), J(cr.current, y)) : B(ar.current, y) && (J(Mr.current.errors, y), D(cr.current, y, !0)), u.label = 6;

            case 6:
              return d = f.next(), [3, 4];

            case 7:
              return [3, 10];

            case 8:
              return p = u.sent(), m = {
                error: p
              }, [3, 10];

            case 9:
              try {
                d && !d.done && (b = f.return) && b.call(f);
              } finally {
                if (m) throw m.error;
              }

              return [7];

            case 10:
              return G(n) && Object.keys(Mr.current.errors).every(function (r) {
                return r in I.current;
              }) ? (Ir({
                errors: {},
                isSubmitting: !0
              }), [4, r(c, a)]) : [3, 12];

            case 11:
              return u.sent(), [3, 15];

            case 12:
              return Mr.current.errors = _e(_e({}, Mr.current.errors), n), t ? [4, t(Mr.current.errors, a)] : [3, 14];

            case 13:
              u.sent(), u.label = 14;

            case 14:
              T && function (r, e) {
                for (var t in r) {
                  if (B(e, t)) {
                    var n = r[t];

                    if (n) {
                      if (n.ref.focus && j(n.ref.focus())) break;

                      if (n.options) {
                        n.options[0].ref.focus();
                        break;
                      }
                    }
                  }
                }
              }(I.current, Mr.current.errors), u.label = 15;

            case 15:
              return [3, 17];

            case 16:
              return Mr.current.isSubmitting = !1, Ir({
                isSubmitted: !0,
                isSubmitting: !1,
                isSubmitSuccessful: G(Mr.current.errors),
                submitCount: Mr.current.submitCount + 1
              }), [7];

            case 17:
              return [2];
          }
        });
      });
    };
  }, [T, Br]);
  r.useEffect(function () {
    x && Wr.current.isValid && ue(), Pr.current = Pr.current || !pr ? Pr.current : function (r, e) {
      var t = new MutationObserver(function () {
        var t, n, u, a;

        try {
          for (var c = i(Object.values(r.current)), o = c.next(); !o.done; o = c.next()) {
            var s = o.value;
            if (s && s.options) try {
              for (var l = (u = void 0, i(s.options)), f = l.next(); !f.done; f = l.next()) {
                var d = f.value;
                d && d.ref && z(d.ref) && e(s);
              }
            } catch (r) {
              u = {
                error: r
              };
            } finally {
              try {
                f && !f.done && (a = l.return) && a.call(l);
              } finally {
                if (u) throw u.error;
              }
            } else s && z(s.ref) && e(s);
          }
        } catch (r) {
          t = {
            error: r
          };
        } finally {
          try {
            o && !o.done && (n = c.return) && n.call(c);
          } finally {
            if (t) throw t.error;
          }
        }
      });
      return t.observe(window.document, {
        childList: !0,
        subtree: !0
      }), t;
    }(I, ce);
  }, [ce, or.current]), r.useEffect(function () {
    return function () {
      Pr.current && Pr.current.disconnect(), yr.current = !0, Object.values(I.current).forEach(function (r) {
        return ce(r, !0);
      });
    };
  }, []), !x && Wr.current.isValid && (Tr.isValid = Y(cr.current, ar.current) && G(Mr.current.errors));
  var fe = {
    trigger: Xr,
    setValue: r.useCallback(function (r, e, t) {
      Zr(r, e, t || {}), re(r) && Ir(), ee(r);
    }, [Zr, Xr]),
    getValues: r.useCallback(ne, []),
    register: r.useCallback(function (r, e) {
      if (!Ar) if (er(r)) se({
        name: r
      }, e);else {
        if (!C(r) || !("name" in r)) return function (e) {
          return e && se(e, r);
        };
        se(r, e);
      }
    }, [or.current]),
    unregister: r.useCallback(function (r) {
      var e, t;

      try {
        for (var n = i(Array.isArray(r) ? r : [r]), u = n.next(); !u.done; u = n.next()) {
          var a = u.value;
          ce(I.current[a], !0);
        }
      } catch (r) {
        e = {
          error: r
        };
      } finally {
        try {
          u && !u.done && (t = n.return) && t.call(n);
        } finally {
          if (e) throw e.error;
        }
      }
    }, []),
    formState: xr ? new Proxy(Tr, {
      get: function get(r, e) {
        if (e in r) return Wr.current[e] = !0, r[e];
      }
    }) : Tr
  },
      de = r.useMemo(function () {
    return _e({
      isFormDirty: $r,
      updateWatchedValue: ae,
      shouldUnregister: q,
      updateFormState: Ir,
      removeFieldEventListener: ie,
      watchInternal: oe,
      mode: Or.current,
      reValidateMode: {
        isReValidateOnBlur: qr,
        isReValidateOnChange: Hr
      },
      validateResolver: x ? ue : void 0,
      fieldsRef: I,
      resetFieldArrayFunctionRef: Fr,
      useWatchFieldsRef: nr,
      useWatchRenderFunctionsRef: ur,
      fieldArrayDefaultValuesRef: $,
      validFieldsRef: cr,
      fieldsWithValidationRef: ar,
      fieldArrayNamesRef: kr,
      readFormStateRef: Wr,
      formStateRef: Mr,
      defaultValuesRef: or,
      shallowFieldsStateRef: wr,
      fieldArrayValuesRef: X
    }, fe);
  }, [or.current, ae, q, ie, oe]);
  return _e({
    watch: function watch(r, e) {
      return oe(r, e);
    },
    control: de,
    handleSubmit: le,
    reset: r.useCallback(function (r, t) {
      var n, u;
      if (void 0 === t && (t = {}), pr) try {
        for (var a = i(Object.values(I.current)), c = a.next(); !c.done; c = a.next()) {
          var s = c.value;

          if (s) {
            var l = s.ref,
                f = s.options,
                d = gr(l) && Array.isArray(f) ? f[0].ref : l;
            if (o(d)) try {
              d.closest("form").reset();
              break;
            } catch (r) {}
          }
        }
      } catch (r) {
        n = {
          error: r
        };
      } finally {
        try {
          c && !c.done && (u = a.return) && u.call(a);
        } finally {
          if (n) throw n.error;
        }
      }
      I.current = {}, or.current = _e({}, r || or.current), r && ee(""), Object.values(Fr.current).forEach(function (r) {
        return ir(r) && r();
      }), wr.current = q ? {} : mr(r || or.current), function (r) {
        var e = r.errors,
            t = r.isDirty,
            n = r.isSubmitted,
            u = r.touched,
            i = r.isValid,
            a = r.submitCount,
            c = r.dirtyFields;
        i || (cr.current = {}, ar.current = {}), $.current = {}, Z.current = new Set(), Rr.current = !1, Ir({
          submitCount: a ? Mr.current.submitCount : 0,
          isDirty: !!t && Mr.current.isDirty,
          isSubmitted: !!n && Mr.current.isSubmitted,
          isValid: !!i && Mr.current.isValid,
          dirtyFields: c ? Mr.current.dirtyFields : {},
          touched: u ? Mr.current.touched : {},
          errors: e ? Mr.current.errors : {},
          isSubmitting: !1,
          isSubmitSuccessful: !1
        });
      }(t);
    }, []),
    clearErrors: r.useCallback(function (r) {
      r && (Array.isArray(r) ? r : [r]).forEach(function (r) {
        return I.current[r] && S(r) ? delete Mr.current.errors[r] : J(Mr.current.errors, r);
      }), Ir({
        errors: r ? Mr.current.errors : {}
      });
    }, []),
    setError: r.useCallback(function (r, t) {
      var n = (I.current[r] || {}).ref;
      D(Mr.current.errors, r, _e(_e({}, t), {
        ref: n
      })), Ir({
        isValid: !1
      }), t.shouldFocus && n && n.focus && n.focus();
    }, []),
    errors: Tr.errors
  }, fe);
}, exports.useFormContext = Vr, exports.useWatch = function (t) {
  var n = t.control,
      u = t.name,
      i = t.defaultValue,
      a = Vr(),
      c = n || a.control,
      o = c.useWatchFieldsRef,
      s = c.useWatchRenderFunctionsRef,
      l = c.watchInternal,
      f = c.defaultValuesRef,
      d = r.useState()[1],
      v = r.useRef(),
      y = r.useRef(i);
  return r.useEffect(function () {
    var r = v.current = wr(),
        e = s.current,
        t = o.current;
    return t[r] = new Set(), e[r] = function () {
      return d({});
    }, l(u, y.current, r), function () {
      delete t[r], delete e[r];
    };
  }, [u, s, o, l, y]), v.current ? l(u, y.current, v.current) : j(i) ? er(u) ? B(f.current, u) : Array.isArray(u) ? u.reduce(function (r, t) {
    var n;
    return _e(_e({}, r), ((n = {})[t] = B(f.current, t), n));
  }, {}) : f.current : i;
};